const gearPath = (cx, cy, rIn, rOut, teeth) => {
  const s = (Math.PI * 2) / teeth;
  let d = '';
  for (let i = 0; i < teeth; i++) {
    const a = i * s;
    const p = (ang, r) => `${(cx + r * Math.cos(ang)).toFixed(2)} ${(cy + r * Math.sin(ang)).toFixed(2)}`;
    const pts = [
      p(a, rIn), p(a + s * 0.18, rIn), p(a + s * 0.28, rOut),
      p(a + s * 0.5, rOut), p(a + s * 0.6, rIn), p(a + s, rIn),
    ];
    d += (i === 0 ? `M${pts[0]}` : `L${pts[0]}`) + pts.slice(1).map((x) => `L${x}`).join('');
  }
  return d + 'Z';
};

const Circuit = () => (
  <svg viewBox="0 0 480 480" fill="none" aria-hidden="true" className="h-full w-full">
    <g stroke="#4a4d52" strokeWidth="1">
      <path d="M20 60 H180 V140 H300 V220 H420" />
      <path d="M60 20 V100 H160 V200 H260 V320 H360 V420" />
      <path d="M460 80 H360 V160 H240 V260 H140 V360 H40" />
      <path d="M100 460 V380 H220 V300 H340" />
      <path d="M420 460 V380 H320" />
      <path d="M20 240 H120 V320" />
      <path d="M460 300 H380 V220" />
      <path d="M240 20 V60 H320" />
    </g>
    <g fill="#63666c">
      <circle cx="20" cy="60" r="4" />
      <circle cx="420" cy="220" r="4" />
      <circle cx="60" cy="20" r="4" />
      <circle cx="360" cy="420" r="4" />
      <circle cx="460" cy="80" r="4" />
      <circle cx="40" cy="360" r="4" />
      <circle cx="100" cy="460" r="4" />
      <circle cx="20" cy="240" r="4" />
      <circle cx="460" cy="300" r="4" />
      <circle cx="240" cy="20" r="4" />
    </g>
    <g stroke="#4a4d52" strokeWidth="1" fill="none">
      <circle cx="180" cy="140" r="7" />
      <circle cx="300" cy="220" r="7" />
      <circle cx="160" cy="200" r="7" />
      <circle cx="260" cy="320" r="7" />
      <circle cx="240" cy="260" r="7" />
      <circle cx="220" cy="380" r="7" />
      <rect x="286" y="106" width="28" height="28" />
      <rect x="126" y="306" width="28" height="28" />
      <rect x="366" y="366" width="28" height="28" />
    </g>
    <g fill="#8b8f96" opacity="0.7">
      <circle cx="180" cy="140" r="2.5" />
      <circle cx="300" cy="220" r="2.5" />
      <circle cx="160" cy="200" r="2.5" />
      <circle cx="260" cy="320" r="2.5" />
      <circle cx="240" cy="260" r="2.5" />
      <circle cx="220" cy="380" r="2.5" />
    </g>
  </svg>
);

const Gear = ({ spin }) => (
  <svg viewBox="0 0 400 400" fill="none" aria-hidden="true" className={`h-full w-full ${spin ? 'animate-spin-slower' : ''}`}>
    <g stroke="#4a4d52" strokeWidth="1">
      <path d={gearPath(200, 200, 118, 150, 14)} />
      <circle cx="200" cy="200" r="88" />
      <circle cx="200" cy="200" r="34" />
      <circle cx="200" cy="200" r="176" strokeDasharray="2 8" />
    </g>
    <g fill="#63666c">
      {[0, 60, 120, 180, 240, 300].map((deg) => {
        const a = (deg * Math.PI) / 180;
        return <circle key={deg} cx={200 + 61 * Math.cos(a)} cy={200 + 61 * Math.sin(a)} r="6" fill="none" stroke="#4a4d52" />;
      })}
    </g>
    <circle cx="200" cy="200" r="12" fill="none" stroke="#63666c" strokeWidth="1" />
  </svg>
);

export const TechDiagram = ({ variant = 'circuit', className = '', spin = false }) => (
  <div className={className} aria-hidden="true">
    {variant === 'circuit' ? <Circuit /> : <Gear spin={spin} />}
  </div>
);
